import {UI} from "../../../../../stem-core/src/ui/UIBase";
import {Link} from "../../../../../stem-core/src/ui/UIPrimitives";

import {iFrameMerchantService} from "../../../../services/IframeMerchantService";
import {authFormService} from "../../../../services/AuthFormService";
import {Messages} from "../../../../Messages";
import {styleRule} from "../../../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../../../stem-core/src/ui/style/Theme";
import {NewsletterSubscribePanelStyle} from "./NewsletterSubscribePanel";
import {BasePanelPage} from "../BasePanelPage";
import {userService} from "../../../../../client/connection/Services";
import {MessageElement} from "../../../../widget/ui/MessageElement";
import {TNR_ALIAS} from "../../../../../blink-sdk/Constants";
import {startDashboardFlow} from "../../../flows/startFlow";


class NewsletterSubscribeSuccessPanelStyle extends NewsletterSubscribePanelStyle {
    @styleRule
    center = {
        textAlign: "center",
    };

    @styleRule
    title = this.themeProps.PAYWALL_TITLE;

    @styleRule
    link = this.themeProps.PAYWALL_LINK;
}

@registerStyle(NewsletterSubscribeSuccessPanelStyle)
export class NewsletterSubscribeSuccessPanel extends BasePanelPage {
    widthValue = 420;

    render() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.title}>{Messages.newsletterSubscribeSuccessTitle(iFrameMerchantService.getMerchant().getName())}</div>,
            iFrameMerchantService.isMerchant(TNR_ALIAS) ?
                <div className={styleSheet.message} style={{padding: "0 6px"}}>You can review your newsletter subscriptions in <Link className={styleSheet.link} onClick={() => startDashboardFlow()}>My Account</Link>.</div>
                : <MessageElement className={styleSheet.message} message={Messages.newsletterSubscribeSuccessText(authFormService.registrationMail || userService.getUserEmail())} />,
        ];
    }
}
